let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9s1QQ")).then(() => parcelRequire('5LINw'));